import ModalConfirmCheckout from "components/ModalConfirmCheckout";
import ModalUploadImage from "components/ModalUploadImage";
import ModalFakturPajak from "components/ModalFakturPajak";
import {
  addPremiumToCart,
  checkoutProcess,
} from "features/common/layouts/cartSlice";
import {
  getServerIdOnly,
  postOrderAPI,
  postUpgradeAPI,
  postRenewAPI,
  postAddonAPI,
} from "helpers/helper";
import { trackGa4Purchase } from "helpers/ga4Ecommerce";
import { fetchBundleRegisterOmgId } from "features/common/layouts/cartAPI";
import ModalLogin from "layouts/ModalLogin";
// import ModalRegister from "layouts/ModalRegister";
import ModalRegisterSimple from "layouts/ModalRegisterSimple";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifySuccess } from "components/ToastMessage";
import ModalSubDomain from "components/ModalSubDomain";
import { Spinner } from "react-bootstrap";
import ModalPph from "components/ModalPph";
import ModalNetInstallation from "components/ModalNetInstallation";
import ModalOrderProgress from "components/ModalOrderProgress";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "components/ErrorBoundary";

const CheckoutButton = ({
  orderProcessName,
  productsList,
  paymentMethod,
  orderProcess,
  requirement,
  promoCode,
  ktpCard,
  conditionalDomain,
  availableOnlineId,
  documentNpwp,
  documentPph,
  documentSuratSubdomain,
  additionalFee,
  subtotal,
  total,
  pricepph,
  domainBundle,
  onlineIdCheckExist,
  orderParams,
}) => {
  const dispatch = useDispatch();
  const {
    productsList: cartProductsList,
    paymentMethod: cartPaymentMethod,
    requirement: cartRequirement,
    promoCode: cartPromoCode,
    total: cartTotal,
    orderProcessName: cartOrderProcessName,
    documentNpwp: cartDocumentNpwp,
    documentPph: cartDocumentPph,
    npwpUrl,
    existingDomain,
    ktpCard: cartKtpCard,
    domainBundle: cartDomainBundle,
    documentSuratSubdomain: cartDocumentSuratSubdomain,
    pricepph: cartPricepph,
  } = useSelector((state) => state.cart);

  const { nameservers } = useSelector((state) => state.domain);
  const { status_login, data_login } = useSelector((state) => state.auth);
  const location = useLocation();
  const [showLogin, setModalLogin] = useState(false);
  const [showDaftar, setModalDaftar] = useState(false);
  const [modalImage, setModalImage] = useState(false);
  const [modalFaktur, setModalFaktur] = useState(false);
  const [modalPph, setModalPph] = useState(false);
  const [modalSubDomain, setModalSubDomain] = useState(false);
  const [modalNetInstallation, setModalNetInstallation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState(false);
  const [isPass, setIsPass] = useState(false);
  const [isNetAvailable, setIsNetAvailable] = useState(false);
  const [isProcessingNetOffer, setIsProcessingNetOffer] = useState(false);
  const [isCheckingPremium, setIsCheckingPremium] = useState(false);
  const [showOrderProgress, setShowOrderProgress] = useState(false);

  const { ktp_client = null } = data_login?.client ?? {};
  const { uploadStatus } = cartKtpCard;
  // const promocode = cartPromoCode?.code ?? null;

  const product = cartProductsList.find((obj) => obj.pid);
  const backorder = cartProductsList.find((obj) => obj.pid === 382);
  const domain = cartProductsList.filter((obj) => obj.domain).map((obj) => obj);
  const pid = cartProductsList.filter((obj) => obj.pid).map((obj) => obj);
  const gid = cartProductsList.filter((obj) => obj.gid).map((obj) => obj);

  const vpnGid = [
    { id: 685, serverName: 'DiegoVPN' }
  ]

  // WordPress Hosting dan VPS tidak lagi memerlukan upload KTP
  // const wordpressServer = [
  //   { id: 706, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)' },
  //   { id: 707, serverName: 'SouthJKT-2 (MTEN - Tier III)' },
  // ]

  // const vpsServer = [
  //   { id: 688, serverName: 'SouthJKT-1 (Cyber 1 - Tier III)' },
  //   { id: 697, serverName: 'SouthJKT-2 (MTEN - Tier III)' },
  //   { id: 701, serverName: 'WestJavaBDG-1 (BBU - Tier III)' },
  //   { id: 725, serverName: 'USA (Tier III)' }
  // ]

  const velocityProduct = useSelector((state) => state.cart.velocityProduct);

  // Reset loading state when user successfully logs in after registration
  useEffect(() => {
    if (status_login === true && (showLogin || showDaftar)) {
      // User has successfully logged in and modals are still open
      // console.log('User logged in, closing modals and resetting loading');
      setModalLogin(false);
      setModalDaftar(false);
      resetLoadingState();
    }
  }, [status_login, showLogin, showDaftar]);

  // Reset loading state when modals are closed
  useEffect(() => {
    if (!showLogin && !showDaftar && loading) {
      // If both modals are closed but loading is still true, reset it
      // console.log('Modals closed, resetting loading state');
      resetLoadingState();
    }
  }, [showLogin, showDaftar, loading]);

  // Additional safety: Reset loading when user becomes logged in
  useEffect(() => {
    if (status_login === true && loading) {
      // console.log('User is logged in, resetting loading as safety measure');
      resetLoadingState();
    }
  }, [status_login, loading]);

  // Listen for internet offer status from CheckoutTable
  useEffect(() => {
    const handleNetOfferStatus = (event) => {
      try {
        const status = event.detail.status;
        // Set isNetAvailable to true only if status is "Tersedia"
        setIsNetAvailable(status === "Tersedia");
      } catch (error) {
        console.warn("Error handling net offer status:", error);
      }
    };

    window.addEventListener('updateInternetOfferStatus', handleNetOfferStatus);
    return () => {
      try {
        window.removeEventListener('updateInternetOfferStatus', handleNetOfferStatus);
      } catch (error) {
        console.warn("Error removing net offer status listener:", error);
      }
    };
  }, []);

  // Reset net offer states when user logs out or leaves order summary page
  useEffect(() => {
    if (!status_login || location.pathname !== "/ordersummary") {
      setIsNetAvailable(false);
      setModalNetInstallation(false);
      setIsProcessingNetOffer(false);
    }
  }, [status_login, location.pathname]);

  // Global error boundary for DOM manipulation errors
  useEffect(() => {
    const handleGlobalError = (event) => {
      if (event.error && event.error.message &&
          (event.error.message.includes('removeChild') ||
           event.error.message.includes('appendChild') ||
           event.error.message.includes('insertBefore'))) {
        console.warn('DOM manipulation error caught and handled:', event.error.message);
        event.preventDefault();
        return false;
      }
    };

    const handleUnhandledRejection = (event) => {
      if (event.reason && event.reason.message &&
          (event.reason.message.includes('removeChild') ||
           event.reason.message.includes('appendChild') ||
           event.reason.message.includes('insertBefore'))) {
        console.warn('DOM manipulation promise rejection caught and handled:', event.reason.message);
        event.preventDefault();
        return false;
      }
    };

    window.addEventListener('error', handleGlobalError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleGlobalError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  const addOrderProcess = async (isNewUser) => {
    try {
      if (!cartPaymentMethod) {
        throw new Error("Metode pembayaran belum dipilih");
      }
      let endpoint;
      let payloadOrderTest = {
        paymentmethod: isNewUser
          ? cartPaymentMethod.valueNewUser
            ? cartPaymentMethod.valueNewUser
            : cartPaymentMethod.value
          : cartPaymentMethod.value,
        amount_total: cartTotal,
        promocode: cartPromoCode?.code,
        npwp: cartRequirement?.company,
        npwp_no: cartRequirement?.company ? cartDocumentNpwp.formData.npwp_no : "",
        npwp_address: cartRequirement?.company ? cartDocumentNpwp.formData.npwp_address : "",
        npwp_company: cartRequirement?.company ? cartDocumentNpwp.formData.npwp_company : "",
        npwp_image: cartRequirement?.company ? npwpUrl : "",
        document_pph: cartRequirement?.pph ? cartDocumentPph.url : "",
        price_pph: cartRequirement?.pph ? cartPricepph : "",
        surat_kuasa_subdomain: cartRequirement?.tos ? cartDocumentSuratSubdomain.suratUrl : "",
        apply_credit: false,
      };

      switch (cartOrderProcessName) {
        case "domain":
          payloadOrderTest["domains"] = domain.map((d) => ({
            domain: d.domain,
            idprotection: d?.isWhois ?? false,
            regperiod: d.duration,
            domaintype: d.type,
            eppcode: d?.eppCode ?? "",
            domain_forwarder:
              d?.domainForwarder === "Activate Later"
                ? null
                : d.domainForwarder || null,
            activate_later: d?.activateLater || false,
          }));

          payloadOrderTest["nameserver"] = nameservers
            ? nameservers
            : [
              "dnsiix1.qwords.net",
              "dnsiix2.qwords.net",
              "dns1.qwords.id",
              "dns2.qwords.id",
            ];

          payloadOrderTest["online_id"] = cartDomainBundle.onlineId || null;
          endpoint = "domain";
          break;
        case "domainBackorder":
          payloadOrderTest["domain"] = backorder.name;
          payloadOrderTest["pid"] = backorder.pid;
          payloadOrderTest["customfields"] = backorder.customfields;
          endpoint = "backorder";
          break;
        case "hosting":
          if (Array.isArray(pid)) {
            // Filter SSL products
            const filteredSsl = pid.filter((pidObj) => pidObj.pid === 110);

            // Filter products that should go to products array (Monitime PID 1146, Email Titan Pro PID 924)
            const productsToProducts = pid.filter((pidObj) => pidObj.pid === 1146 || pidObj.pid === 924);

            // Filter actual hosting products (exclude SSL, Monitime, Email Titan Pro)
            const filteredPid = pid.filter((pidObj) => pidObj.pid !== 110 && pidObj.pid !== 1146 && pidObj.pid !== 924);

            // Process hosting products
            payloadOrderTest["hostings"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = pidObj?.addon ? [pidObj?.addon.id] : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }
              // console.log(velocityProduct);
              // Jika ada velocityProduct dan GID sesuai (730 atau 731), gunakan data velocityProduct
              if (velocityProduct && (pidObj.gid === 730 || pidObj.gid === 731)) {
                return {
                  pid: velocityProduct.pid, // Gunakan PID dari velocityProduct
                  billingcycle: velocityProduct.billingcycle,
                  addons: addons,
                  price: velocityProduct.priceWithAddon || velocityProduct.price,
                };
              }

              // Jika tidak ada velocityProduct, gunakan data normal
              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                addons: addons,
                price: pidObj?.price ? pidObj.price : 0,
              };
            });

            // Validasi hosting payload
            // console.log("Hosting payload:", JSON.stringify(payloadOrderTest["hostings"], null, 2));

            // Process products that should go to products array
            payloadOrderTest["products"] = productsToProducts.map((pidObj) => ({
              pid: pidObj.pid,
              billingcycle: pidObj.billingcycle,
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: pidObj?.addon ? [pidObj?.addon.id] : [],
            }));
            payloadOrderTest["ssl"] = filteredSsl.map((pidObj) => ({
              pid: pidObj.pid,
              price: pidObj.price,
              billingcycle: pidObj?.billingcycle ?? pidObj?.duration ?? "",
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: pidObj?.addon ? [pidObj?.addon.id] : [],
            }));
          } else {
            payloadOrderTest["hostings"] = [];
            payloadOrderTest["ssl"] = [];
          }

          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: item.duration,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }

          gid.forEach(function (item) {
            if (item.gid === 709 || item.gid === "709") {
              payloadOrderTest["nameserver"] = nameservers
                ? nameservers
                : ["ns1.fastcloud.id", "ns2.fastcloud.id"];
            } else {
              if (nameservers) {
                payloadOrderTest["nameserver"] = nameservers;
              }
            }
          });

          if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === ""
          ) {
            payloadOrderTest["notes"] = "Gratis kaos dan tumbler";
          } else if (
            cartPromoCode.customPromo === "" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] = "Gratis Payment Gateway";
          } else if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] =
              "Gratis kaos dan tumbler dan Gratis Payment Gateway";
          }

          if (payloadOrderTest["hostings"].length === 0) {
            // Jika tidak ada hosting, tambahkan nameserver dan online_id seperti domain order
            payloadOrderTest["nameserver"] = nameservers
              ? nameservers
              : [
                "dnsiix1.qwords.net",
                "dnsiix2.qwords.net",
                "dns1.qwords.id",
                "dns2.qwords.id",
              ];
            payloadOrderTest["online_id"] = cartDomainBundle.onlineId || null;

            // Update format domains untuk domain-only order
            payloadOrderTest["domains"] = domain.map((d) => ({
              domain: d.domain,
              idprotection: d?.isWhois ?? false,
              regperiod: d.duration,
              domaintype: d.type,
              eppcode: d?.eppCode ?? "",
              domain_forwarder:
                d?.domainForwarder === "Activate Later"
                  ? null
                  : d.domainForwarder || null,
              activate_later: d?.activateLater || false,
            }));

            endpoint = "domain";
          } else {
            endpoint = "hosting";
          }

          // Validasi final payload untuk hosting
          // console.log("Final hosting endpoint:", endpoint);
          // console.log("Final hosting payload:", JSON.stringify(payloadOrderTest, null, 2));
          break;
        case "migrasiHosting":
          if (Array.isArray(pid)) {
            const filteredPid = pid.filter((pidObj) => pidObj.pid !== 110);
            const filteredSsl = pid.filter((pidObj) => pidObj.pid === 110);
            payloadOrderTest["hostings"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = pidObj?.addon ? [pidObj?.addon.id] : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }

              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                addons: addons,
                price: pidObj?.price ? pidObj.price : 0,
              };
            });

            payloadOrderTest["ssl"] = filteredSsl.map((pidObj) => ({
              pid: pidObj.pid,
              price: pidObj.price,
              billingcycle: pidObj?.billingcycle ?? pidObj?.duration ?? "",
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: pidObj?.addon ? [pidObj?.addon.id] : [],
            }));
          } else {
            payloadOrderTest["hostings"] = [];
            payloadOrderTest["ssl"] = [];
          }

          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: item.duration,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }
          gid.forEach(function (item) {
            if (item.gid === 709 || item.gid === "709") {
              payloadOrderTest["nameserver"] = nameservers
                ? nameservers
                : ["ns1.fastcloud.id", "ns2.fastcloud.id"];
            } else {
              if (nameservers) {
                payloadOrderTest["nameserver"] = nameservers;
              }
            }
          });
          if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === ""
          ) {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting dan gratis kaos dan tumbler";
          } else if (
            cartPromoCode.customPromo === "" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting dan gratis payment gateway";
          } else if (
            cartPromoCode.customPromo === "Promo Kaos Tumbler" &&
            cartPromoCode.paymentGateway === "Gratis Payment Gateway"
          ) {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting, gratis kaos dan tumbler dan gratis payment gateway";
          } else {
            payloadOrderTest["notes"] =
              "Invoice ini meminta untuk melakukan migrasi hosting";
          }
          endpoint = "hosting";
          break;
        case "vps":
          if (Array.isArray(pid)) {
            const filteredPid = pid.filter(
              (pidObj) => pidObj.pid !== 110 && pidObj.pid !== 449
            );
            const filteredSsl = pid.filter(
              (pidObj) => pidObj.pid === 110 || pidObj.pid === 449
            );

            payloadOrderTest["hostings"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = pidObj?.addon ? [pidObj?.addon.id] : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }

              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                addons: addons,
                price: pidObj?.price ? pidObj.price : 0,
              };
            });
            payloadOrderTest["vps"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = Array.isArray(pidObj?.vpsaddons)
                ? pidObj.vpsaddons.map((addon) => addon.id)
                : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }

              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                hostname: pidObj.hostname,
                rootpw: pidObj.password,
                addons: addons,
                customfields: Array.isArray(pidObj?.customfields)
                  ? pidObj.customfields.map((cf) => ({
                    id: cf.id,
                    value: cf.value,
                  }))
                  : [],
                configoptions: Array.isArray(pidObj?.configoptions)
                  ? pidObj.configoptions.map((co) => ({
                    id: co.id,
                    value: co.value,
                  }))
                  : [],
              };
            });

            payloadOrderTest["ssl"] = filteredSsl.map((pidObj) => ({
              pid: pidObj.pid,
              price: pidObj.price,
              billingcycle: pidObj?.billingcycle ?? pidObj?.duration ?? "",
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: pidObj?.addon ? [pidObj?.addon.id] : [],
            }));
          } else {
            payloadOrderTest["vps"] = [];
            payloadOrderTest["ssl"] = [];
          }

          endpoint = "vps";
          break;
        case "server":
          if (Array.isArray(pid)) {
            const filteredPid = pid.filter(
              (pidObj) => pidObj.pid !== 110 && pidObj.pid !== 449
            );
            const filteredSsl = pid.filter(
              (pidObj) => pidObj.pid === 110 || pidObj.pid === 449
            );

            payloadOrderTest["hostings"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = pidObj?.addon ? [pidObj?.addon.id] : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }

              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                addons: addons,
                price: pidObj?.price ? pidObj.price : 0,
              };
            });
            payloadOrderTest["vps"] = filteredPid.map((pidObj) => {
              // Initialize addons array
              let addons = Array.isArray(pidObj?.vpsaddons)
                ? pidObj.vpsaddons.map((addon) => addon.id)
                : [];

              // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
              if (cartDocumentPph.url) {
                addons.push(55); // Add addon ID 55
              }

              return {
                pid: pidObj.pid,
                billingcycle: pidObj.billingcycle,
                hostname: pidObj.hostname,
                rootpw: pidObj.password,
                addons: addons,
                customfields: Array.isArray(pidObj?.customfields)
                  ? pidObj.customfields.map((cf) => ({
                    id: cf.id,
                    value: cf.value,
                  }))
                  : [],
                configoptions: Array.isArray(pidObj?.configoptions)
                  ? pidObj.configoptions.map((co) => ({
                    id: co.id,
                    value: co.value,
                  }))
                  : [],
              };
            });

            payloadOrderTest["ssl"] = filteredSsl.map((pidObj) => ({
              pid: pidObj.pid,
              price: pidObj.price,
              billingcycle: pidObj?.billingcycle ?? pidObj?.duration ?? "",
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: pidObj?.addon ? [pidObj?.addon.id] : [],
            }));
          } else {
            payloadOrderTest["vps"] = [];
            payloadOrderTest["ssl"] = [];
          }

          endpoint = "vps";
          break;
        case "diegoVpn":
          let product_account = [];
          pid.map((p) => {
            for (let j = 0; j < p.account; j++) {
              product_account.push(p);
            }
            return null;
          });
          payloadOrderTest["products"] = product_account;
          endpoint = "general";
          break;
        case "upgrade":
          // Handle upgrade products - this will be processed by postUpgradeAPI
          const upgradeItems = cartProductsList.filter(item => item.type === "upgrade");
          payloadOrderTest["upgrades"] = upgradeItems.map(item => ({
            serviceid: item.serviceid,
            pid: item.pid,
            billingcycle: item.billingcycle,
            price: item.price,
            upgradeType: item.upgradeType || 'package',
            configOptionId: item.configOptionId,
            configOptionValue: item.configOptionValue,
            upgradeDetails: item.upgradeDetails || {}
          }));
          endpoint = "upgrade";
          break;
        case "renew":
          // Handle renewal products - this will be processed by postRenewAPI
          const renewalItems = cartProductsList.filter(item => item.type === "renew");
          payloadOrderTest["renewals"] = renewalItems.map(item => ({
            serviceid: item.serviceid,
            domainid: item.domainid,
            type: item.renewType || 'hosting',
            price: item.price,
            billingcycle: item.billingcycle,
            period: item.period
          }));

          // Note: Convenience fee will be automatically added by WHMCS hook based on payment method
          // No need to send convenience fee from frontend

          endpoint = "renew";
          break;
        case "addon":
          // Handle addon products - this will be processed by postAddonAPI
          const addonItems = cartProductsList.filter(item => item.type === "addon");
          payloadOrderTest["addons"] = addonItems.map(item => ({
            serviceid: item.serviceid,
            pid: item.pid,
            name: item.name,
            billingcycle: item.billingcycle,
            price: item.price,
            addonType: item.addonType || 'recurring',
            addonDetails: item.addonDetails || {}
          }));
          endpoint = "addon";
          break;
        case "emailsuite":
          payloadOrderTest["products"] = pid.map((pidObj) => {
            // Handle addons
            let addons = [];
            if (Array.isArray(pidObj?.addon)) {
              // Array format
              addons = pidObj.addon.map(a => a.id).filter(id => id !== null && id !== undefined);
            } else if (pidObj?.addon?.id) {
              // Single object format
              addons = [pidObj.addon.id];
            }

            // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
            if (cartDocumentPph.url) {
              addons.push(55);
            }

            return {
              pid: pidObj.pid,
              billingcycle: pidObj.billingcycle || pidObj.duration,
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: addons,
            };
          });
          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: item.duration,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }
          endpoint = "general";
          break;
        case "objectStorage":
          // Object Storage (pid 1198 atau dari URL) - kirim sebagai products dengan configoptions (Storage GB)
          payloadOrderTest["products"] = pid.map((pidObj) => {
            let addons = [];
            if (Array.isArray(pidObj?.addon)) {
              addons = pidObj.addon.map(a => a.id).filter(id => id != null);
            } else if (pidObj?.addon?.id) {
              addons = [pidObj.addon.id];
            }
            if (cartDocumentPph.url) addons.push(55);
            return {
              pid: pidObj.pid,
              billingcycle: pidObj.billingcycle || pidObj.duration || "monthly",
              customfields: Array.isArray(pidObj?.customfields) ? pidObj.customfields.map((cf) => ({ id: cf.id, value: cf.value })) : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions
                  .filter((co) => co && co.id !== null && co.id !== undefined && String(co.id).trim() !== "")
                  .map((co) => ({ id: co.id, value: co.value }))
                : [],
              addons,
            };
          });
          if (existingDomain) payloadOrderTest["domains"] = [{ ...existingDomain, idprotection: false }];
          else payloadOrderTest["domains"] = domain.map((item) => ({ domain: item.domain, idprotection: item?.whois ?? false, regperiod: 2, domaintype: item.type, eppcode: item?.eppCode ?? "" }));
          endpoint = "general";
          break;
        default: // ? orderProcessName = 'others'
          payloadOrderTest["products"] = pid.map((pidObj) => {
            // Handle addons - Digital Signature sends array of addon objects
            let addons = [];
            if (Array.isArray(pidObj?.addon)) {
              // Array format (e.g., Digital Signature)
              addons = pidObj.addon.map(a => a.id).filter(id => id !== null && id !== undefined);
            } else if (pidObj?.addon?.id) {
              // Single object format
              addons = [pidObj.addon.id];
            }

            // Check if cartDocumentPph.url is not empty and add addon ID 55 if true
            if (cartDocumentPph.url) {
              addons.push(55);
            }

            return {
              pid: pidObj.pid,
              billingcycle: pidObj.billingcycle || pidObj.duration,
              customfields: Array.isArray(pidObj?.customfields)
                ? pidObj.customfields.map((cf) => ({
                  id: cf.id,
                  value: cf.value,
                }))
                : [],
              configoptions: Array.isArray(pidObj?.configoptions)
                ? pidObj.configoptions.map((co) => ({
                  id: co.id,
                  value: co.value,
                }))
                : [],
              addons: addons,
            };
          });
          if (existingDomain) {
            payloadOrderTest["domains"] = [
              { ...existingDomain, idprotection: false },
            ];
          } else {
            payloadOrderTest["domains"] = domain.map((item) => ({
              domain: item.domain,
              idprotection: item?.whois ?? false,
              regperiod: 2,
              domaintype: item.type,
              eppcode: item?.eppCode ?? "",
            }));
          }
          endpoint = "general";
          break;
      }

      // Use different API for upgrade, renew, and addon orders
      let orderResult;
      if (endpoint === "upgrade") {
        orderResult = await postUpgradeAPI(payloadOrderTest);
      } else if (endpoint === "renew") {
        orderResult = await postRenewAPI(payloadOrderTest);
      } else if (endpoint === "addon") {
        orderResult = await postAddonAPI(payloadOrderTest);
      } else {
        orderResult = await postOrderAPI(payloadOrderTest, endpoint);
      }

      return orderResult;
    } catch (error) {
      console.log(error.message);
      // notifyError(error.message);
      const errorPayload = {
        code: 500,
        result: error.message,
        msg: error.message,
        data: null
      };
      dispatch(checkoutProcess(false));
      return errorPayload;
    }
  };

  const resetLoadingState = () => {
    // console.log('Resetting loading state');
    setLoading(false);
    setIsCheckingPremium(false);
  };

  const handlerCloseModal = () => {
    setModalConfirmation(false);
    setIsPass(true);
    resetLoadingState();
  };

  const redirectToInvoice = (invoiceId, { recordGa4Purchase = false } = {}) => {
    if (recordGa4Purchase && invoiceId) {
      trackGa4Purchase(String(invoiceId), cartTotal, cartProductsList);
    }
    // Clear localStorage safely to avoid DOM manipulation errors
    try {
      localStorage.removeItem("persist:root");
    } catch (error) {
      console.warn("Failed to clear localStorage:", error);
    }

    // Use setTimeout to ensure DOM operations complete before redirect
    setTimeout(() => {
      try {
        window.location.href = `${process.env.REACT_APP_BASE_API}viewinvoice.php?id=${invoiceId}`;
      } catch (error) {
        console.warn("Error during redirect:", error);
        // Fallback redirect
        window.location.replace(`${process.env.REACT_APP_BASE_API}viewinvoice.php?id=${invoiceId}`);
      }
    }, 100);
  };

  const checkoutHandle = async (e) => {
    // Prevent multiple clicks
    if (loading || isProcessingNetOffer || isCheckingPremium) {
      return;
    }

    // Set loading state immediately to prevent multiple clicks
    setLoading(true);
    e.target.disabled = true;
    e.target.innerText = "Loading...";

    if (
      domain &&
      (cartOrderProcessName === "domain" ||
        cartOrderProcessName === "hosting" ||
        cartOrderProcessName === "migrasiHosting")
    ) {
      // Set premium checking state
      setIsCheckingPremium(true);
      e.target.innerText = "Mengecek Domain Premium...";

      // Process premium domain checks in parallel with shorter timeout
      const premiumChecks = domain.map(async (name) => {
        try {
          const premium = cartProductsList.find(
            (obj) => obj.premium_domain === name.domain
          );
          if (premium) {
            return null; // Already premium
          }

          // Reduced timeout to 3 seconds
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 3000);

          try {
            const response = await fetch(
              `${process.env.REACT_APP_BASE_API}apis/checkPremium.php?domain=${name.domain}`,
              { signal: controller.signal }
            );
            clearTimeout(timeoutId);
            const result = await response.json();

            if (result?.datas?.data?.isPremium === 1) {
              return {
                name: "Biaya One Time",
                price: result.datas.data.price.IDR - name.price,
                type: "Premium Domain",
                premium_domain: name.domain,
              };
            }
            return null;
          } catch (error) {
            // If timeout or error, bypass premium check for this domain
            clearTimeout(timeoutId);
            return null;
          }
        } catch (error) {
          console.log("Premium check error:", error);
          return null;
        }
      });

      try {
        // Wait for all premium checks to complete (max 3 seconds)
        const premiumResults = await Promise.allSettled(premiumChecks);

        // Process premium results
        let hasPremium = false;
        premiumResults.forEach((result) => {
          if (result.status === 'fulfilled' && result.value) {
            dispatch(addPremiumToCart(result.value));
            hasPremium = true;
          }
        });

        if (hasPremium) {
          notifySuccess("Domain yang Anda pesan adalah Domain Premium.");
          setLoading(false);
          setIsCheckingPremium(false);
          e.target.disabled = false;
          e.target.innerText = "Selesaikan Pesananmu";
          return;
        }

        // Reset premium checking state
        setIsCheckingPremium(false);
      } catch (error) {
        console.log("Premium check processing error:", error);
        // Reset premium checking state
        setIsCheckingPremium(false);
        // Continue with checkout even if premium check fails
      }
    }

    if (status_login === false) {
      // console.log('User not logged in, showing login modal');
      setModalLogin(true);
      resetLoadingState(); // Reset loading state when showing login modal
      setIsCheckingPremium(false); // Reset premium checking state
      e.target.disabled = false;
      e.target.innerText = "Selesaikan Pesananmu";
      return;
    }

    if (cartOrderProcessName === "hosting" && !isPass) {
      let hostings = {};
      hostings["hosting"] = Object.values(pid).map((pidObj) => ({
        pid: pidObj.pid,
        billingcycle: pidObj.billingcycle,
        addons: pidObj?.addon ? [pidObj?.addon.id] : [],
      }));
      if (hostings["hosting"].length === 0) {
        setModalConfirmation(true);
        setLoading(false);
        setIsCheckingPremium(false);
        e.target.disabled = false;
        e.target.innerText = "Selesaikan Pesananmu";
        return;
      }
    }

    try {
      /**
       *  TODO : Show modal upload KTP or Open Camera for (DiegoVPN, Colocation & Dedicated Server)
       *  NOTE:
       *  - Modal upload KTP dinonaktifkan untuk Managed VPS (GID 734 dengan PID 1167-1170)
       *  - Modal upload KTP dinonaktifkan untuk VPS biasa
       *  - Modal upload KTP dinonaktifkan untuk WordPress Hosting
       */
      // Hanya DiegoVPN yang perlu upload KTP (Colocation & Dedicated Server bisa ditambahkan jika ada)
      const mergedServer = getServerIdOnly(vpnGid);

      // Skip modal upload KTP untuk semua VPS (termasuk Managed VPS) dan WordPress Hosting
      // Hanya DiegoVPN yang perlu upload KTP
      if (mergedServer.includes(product?.gid) && !ktp_client) {
        if (uploadStatus !== "user_agree") {
          setModalImage(true);
          setLoading(false);
          setIsCheckingPremium(false);
          e.target.disabled = false;
          e.target.innerText = "Selesaikan Pesananmu";
          return;
        }
      }

      if (
        existingDomain &&
        existingDomain.domain &&
        !cartDocumentSuratSubdomain.suratUrl
      ) {
        let tldString;
        let domainName;
        let isSubdomain;
        let tld = existingDomain.domain.split(".");
        let arrConditionalDomain = [
          ".ac.id",
          ".co.id",
          ".sch.id",
          ".or.id",
          ".ponpes.id",
          ".web.id",
          ".go.id",
        ];
        if (tld.length === 4) {
          tldString = "." + tld[2] + "." + tld[3];
          domainName = tld[1] + "." + tld[2] + "." + tld[3];
          isSubdomain = true;
        } else if (tld.length === 3) {
          tldString = "." + tld[1] + "." + tld[2];
          domainName = tld[0] + "." + tld[1] + "." + tld[2];
          isSubdomain = false;
        } else {
          tldString = "." + tld[1];
          domainName = tld[0] + "." + tld[1];
          isSubdomain = false;
        }

        if (arrConditionalDomain.includes(tldString) && isSubdomain) {
          setLoading(true);
          try {
            const clientId = data_login?.client?.id;
            if (!clientId) {
              console.log("Client ID not found for domain check");
              setLoading(false);
              return;
            }

            const response = await fetch(
              `${process.env.REACT_APP_BASE_API}/apis/checkOwnerDomain.php?domain=${domainName}&clientid=${clientId}`
            );
            const data = await response.json();
            if (data.code !== "200") {
              setModalSubDomain(true);
              setLoading(false);
              setIsCheckingPremium(false);
              e.target.disabled = false;
              e.target.innerText = "Selesaikan Pesananmu";
              return;
            } else {
              setLoading(false);
              setIsCheckingPremium(false);
            }
          } catch (error) {
            console.log(error);
            setLoading(false);
            setIsCheckingPremium(false);
          }
        }
      }

      if (cartRequirement?.company === true && !npwpUrl) {
        setModalFaktur(true);
        setLoading(false);
        setIsCheckingPremium(false);
        e.target.disabled = false;
        e.target.innerText = "Selesaikan Pesananmu";
        return;
      }

      if (cartRequirement?.pph === true && !cartDocumentPph.url) {
        setModalPph(true);
        setLoading(false);
        setIsCheckingPremium(false);
        e.target.disabled = false;
        e.target.innerText = "Selesaikan Pesananmu";
        return;
      }

      // Check net installation offer before checkout
      if (location.pathname === "/ordersummary" && isNetAvailable && !isProcessingNetOffer) {
        setModalNetInstallation(true);
        setLoading(false);
        setIsCheckingPremium(false);
        e.target.disabled = false;
        e.target.innerText = "Selesaikan Pesananmu";
        return;
      }

      setShowOrderProgress(true);

      if (cartProductsList.length === 0) {
        setTimeout(() => {
          e.target.innerText = "Selesaikan Pesananmu";
          e.target.disabled = false;
          dispatch(checkoutProcess(false));
          setLoading(false);
          setIsCheckingPremium(false);
        }, 2000);
        return;
      }

      let isNewUser = true;

      // if(data_login){
      // 	const userCreatedAt = new Date(data_login.user.created_at);
      // 	const cutoffDate = new Date('2023-10-11T00:00:00');

      // 	if (userCreatedAt >= cutoffDate) {
      // 		isNewUser = true;
      // 	} else {
      // 		isNewUser = false;
      // 	}
      // }

      // console.log("Sebelum addOrderProcess");
      const order = await addOrderProcess(isNewUser);
      // console.log("Order response:", JSON.stringify(order, null, 2));
      // console.log("Cart order process name:", cartOrderProcessName);
      // console.log("Cart products:", cartProductsList);

      // Validasi order response
      if (!order) {
        throw new Error("Tidak ada response dari server");
      }

      // Special handling for trial products (PID 1157) that return 400 with "Invoice ID Not Found"
      if (order?.code === 400) {
        // Check if this is a trial product (PID 1157) and the error is "Invoice ID Not Found"
        const isTrialProduct = cartProductsList.some(item => item.pid === 1157);
        const isInvoiceNotFoundError = order?.msg?.includes("Invoice ID Not Found") ||
          order?.error?.message?.includes("Invoice ID Not Found") ||
          order?.message?.includes("Invoice ID Not Found");

        if (isTrialProduct && isInvoiceNotFoundError) {
          // This is expected for trial products - show success message and redirect
          notifySuccess("Pesanan Trial berhasil!");
          setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_BASE_API}clientarea.php`;
          }, 2000);
          return;
        } else {
          // For other 400 errors, throw as usual
          throw new Error(order?.msg || order?.message || "Bad Request");
        }
      }
        if (
          cartOrderProcessName === "domain" ||
          cartOrderProcessName === "hosting" ||
          cartOrderProcessName === "migrasiHosting" ||
          cartOrderProcessName === "emailsuite" ||
          cartOrderProcessName === "domainBackorder" ||
          cartOrderProcessName === "server"
        ) {
          if (order?.data?.order?.result === "success") {
            const invoiceId = order.data.order.invoiceid;

            // Register omg.id if domain bundle with onlineId exists and user doesn't have omg.id account
            if (cartDomainBundle?.onlineId && !onlineIdCheckExist && status_login) {
              // Ensure password and password_confirmation are the same
              const password = cartDomainBundle.password || '';
              const password_confirmation = cartDomainBundle.password_confirmation || password;

              const omgIdData = {
                username: cartDomainBundle.onlineId,
                name: cartDomainBundle.name || data_login?.client?.firstname || data_login?.user?.first_name || cartDomainBundle.onlineId,
                email: cartDomainBundle.email || data_login?.user?.email || data_login?.client?.email || '',
                password: password,
                password_confirmation: password_confirmation, // Always use same password
                invoice_id: invoiceId,
                client_id: data_login?.client?.id || data_login?.user?.id || 0,
              };

              // Only register if we have all required data
              if (omgIdData.username && omgIdData.email && omgIdData.password) {
                fetchBundleRegisterOmgId(omgIdData)
                  .then((result) => {
                    if (result.code === 200) {
                      console.log("Omg.id registration data saved successfully:", result);
                    } else {
                      console.error("Failed to save omg.id registration:", result);
                    }
                  })
                  .catch((error) => {
                    console.error("Error saving omg.id registration:", error);
                  });
              }
            }

            // Keep modal open until redirect happens
            setTimeout(() => {
              redirectToInvoice(invoiceId, { recordGa4Purchase: true });
            }, 5000); // 5 seconds
          } else {
          setShowOrderProgress(false);
          setTimeout(() => {
            e.target.innerText = "Selesaikan Pesananmu";
            e.target.disabled = false;
            dispatch(checkoutProcess(false));
            setLoading(false);
            notifyError(order?.result || order?.msg || "Terjadi kesalahan saat memproses pesanan");
          }, 2000);
        }
      } else if (cartOrderProcessName === "upgrade") {
        // Handle upgrade response
        if (order?.code === 200 && order?.data?.order?.result === "success") {
          // Keep modal open until redirect happens
          setTimeout(() => {
            redirectToInvoice(order.data.order.invoiceid, { recordGa4Purchase: true });
          }, 5000); // 5 seconds
        } else if (order?.code === 200 && order?.data?.existing_order) {
          // Handle case: existing unpaid invoice or existing order
          const invoiceId = order.data.existing_order.invoiceid || order.data.payment_url?.split('/invoice/')[1];
          if (invoiceId) {
            notifyError(order?.message || "Ada invoice yang belum dibayar. Mengarahkan ke invoice...");
            // Keep modal open until redirect happens
            setTimeout(() => {
              redirectToInvoice(invoiceId);
            }, 5000); // 5 seconds delay
          } else {
            setShowOrderProgress(false);
            setTimeout(() => {
              e.target.innerText = "Selesaikan Pesananmu";
              e.target.disabled = false;
              dispatch(checkoutProcess(false));
              setLoading(false);
              notifyError(order?.message || "Terjadi kesalahan saat memproses upgrade");
            }, 2000);
          }
        } else if (order?.data?.payment_url) {
          // Handle case: unpaid invoice with payment_url
          const invoiceId = order.data.payment_url.split('/invoice/')[1];
          if (invoiceId) {
            notifyError(order?.message || "Ada invoice yang belum dibayar. Mengarahkan ke invoice...");
            // Keep modal open until redirect happens
            setTimeout(() => {
              redirectToInvoice(invoiceId);
            }, 5000); // 5 seconds delay
          } else {
            setShowOrderProgress(false);
            setTimeout(() => {
              e.target.innerText = "Selesaikan Pesananmu";
              e.target.disabled = false;
              dispatch(checkoutProcess(false));
              setLoading(false);
              notifyError(order?.error || order?.message || "Terjadi kesalahan saat memproses upgrade");
            }, 2000);
          }
        } else {
          setShowOrderProgress(false);
          setTimeout(() => {
            e.target.innerText = "Selesaikan Pesananmu";
            e.target.disabled = false;
            dispatch(checkoutProcess(false));
            setLoading(false);
            notifyError(order?.error || order?.message || "Terjadi kesalahan saat memproses upgrade");
          }, 2000);
        }
      } else if (cartOrderProcessName === "renew") {
        // Handle renew response
        if (order?.code === 200 && order?.data?.order?.result === "success") {
          // Keep modal open until redirect happens
          setTimeout(() => {
            redirectToInvoice(order.data.order.invoiceid, { recordGa4Purchase: true });
          }, 5000); // 5 seconds
        } else {
          setShowOrderProgress(false);
          setTimeout(() => {
            e.target.innerText = "Selesaikan Pesananmu";
            e.target.disabled = false;
            dispatch(checkoutProcess(false));
            setLoading(false);
            notifyError(order?.error || order?.message || "Terjadi kesalahan saat memproses perpanjangan");
          }, 2000);
        }
      } else if (cartOrderProcessName === "addon") {
        // Handle addon response
        if (order?.code === 200 && order?.data?.order?.result === "success") {
          // Keep modal open until redirect happens
          setTimeout(() => {
            redirectToInvoice(order.data.order.invoiceid, { recordGa4Purchase: true });
          }, 5000); // 5 seconds
        } else {
          setShowOrderProgress(false);
          setTimeout(() => {
            e.target.innerText = "Selesaikan Pesananmu";
            e.target.disabled = false;
            dispatch(checkoutProcess(false));
            setLoading(false);
            notifyError(order?.error || order?.message || "Terjadi kesalahan saat memproses addon");
          }, 2000);
        }
        } else {
          if (order?.code === 200 && order?.data?.order) {
            const { invoiceid = 0 } = order.data.order;
            setIsProcessingNetOffer(false); // Reset processing state
            // Keep modal open until redirect happens
            redirectToInvoice(invoiceid, {
              recordGa4Purchase:
                order?.data?.order?.result === "success" && Number(invoiceid) > 0,
            });
          } else {
            // Handle case where order response is not as expected
            console.error("Order response error:", order);
            setShowOrderProgress(false);
            e.target.innerText = "Selesaikan Pesananmu";
            e.target.disabled = false;
            dispatch(checkoutProcess(false));
            setLoading(false);
            setIsProcessingNetOffer(false); // Reset processing state
            notifyError(order?.result || order?.msg || order?.error || "Format response tidak valid");
          }
        }
       } catch (err) {
       console.warn(err.message, "checkoutHandle Function");
       setShowOrderProgress(false);
       if (err.message === "Invalid Data") {
         notifyError(
           "Pemesanan Anda tidak valid. Silakan ulangi pemesanan Anda."
         );
       } else {
         notifyError(err.message);
       }
       try {
         if (e.target && e.target.parentNode) {
           e.target.innerText = "Selesaikan Pesananmu";
           e.target.disabled = false;
         }
       } catch (error) {
         console.warn("Error resetting button in checkoutHandle:", error);
       }
       dispatch(checkoutProcess(false));
       setLoading(false);
       setIsProcessingNetOffer(false); // Reset processing state
     }
  };

  const modalHideHandler = () => {
    setModalImage(false);
    resetLoadingState();
  };

  const handleNetInstallationSkip = () => {
    setModalNetInstallation(false);
    setIsNetAvailable(false); // Mark as not available so it won't show again
    setIsProcessingNetOffer(true); // Prevent multiple triggers
    // Continue with checkout process
    continueCheckout();
  };

  const handleNetInstallationAccept = () => {
    setModalNetInstallation(false);
    setIsNetAvailable(false); // Mark as not available so it won't show again
    setIsProcessingNetOffer(true); // Prevent multiple triggers
    // Continue with checkout process
    continueCheckout();
  };

  const handleNetInstallationHide = () => {
    setModalNetInstallation(false);
    setIsProcessingNetOffer(false); // Reset processing state
    resetLoadingState();
  };

  const continueCheckout = async () => {
    const checkoutButton = document.getElementById("checkoutButton");
    if (checkoutButton) {
      try {
        checkoutButton.innerText = "Loading...";
        checkoutButton.disabled = true;
        setShowOrderProgress(true);
      } catch (error) {
        console.warn("Error updating checkout button:", error);
        setShowOrderProgress(true);
      }

      if (cartProductsList.length === 0) {
        setTimeout(() => {
          try {
            if (checkoutButton && checkoutButton.parentNode) {
              checkoutButton.innerText = "Selesaikan Pesananmu";
              checkoutButton.disabled = false;
            }
            dispatch(checkoutProcess(false));
            setLoading(false);
          } catch (error) {
            console.warn("Error resetting checkout button:", error);
            dispatch(checkoutProcess(false));
            setLoading(false);
          }
        }, 2000);
        return;
      }

      try {
        let isNewUser = true;
        const order = await addOrderProcess(isNewUser);
        console.log("Order response:", JSON.stringify(order, null, 2));

        // Validasi order response
        if (!order) {
          throw new Error("Tidak ada response dari server");
        }

        // Special handling for trial products (PID 1157) that return 400 with "Invoice ID Not Found"
        if (order?.code === 400) {
          // Check if this is a trial product (PID 1157) and the error is "Invoice ID Not Found"
          const isTrialProduct = cartProductsList.some(item => item.pid === 1157);
          const isInvoiceNotFoundError = order?.msg?.includes("Invoice ID Not Found") ||
            order?.error?.message?.includes("Invoice ID Not Found") ||
            order?.message?.includes("Invoice ID Not Found");

          if (isTrialProduct && isInvoiceNotFoundError) {
            // This is expected for trial products - show success message and redirect
            notifySuccess("Pesanan Trial berhasil!");
            setTimeout(() => {
              window.location.href = `${process.env.REACT_APP_BASE_API}clientarea.php`;
            }, 2000);
            return;
          } else {
            // For other 400 errors, throw as usual
            throw new Error(order?.msg || order?.message || "Bad Request");
          }
        }

        if (
          cartOrderProcessName === "domain" ||
          cartOrderProcessName === "hosting" ||
          cartOrderProcessName === "migrasiHosting" ||
          cartOrderProcessName === "emailsuite" ||
          cartOrderProcessName === "domainBackorder" ||
          cartOrderProcessName === "server"
        ) {
          if (order?.data?.order?.result === "success") {
            const invoiceId = order.data.order.invoiceid;

            // Register omg.id if domain bundle with onlineId exists and user doesn't have omg.id account
            if (cartDomainBundle?.onlineId && !onlineIdCheckExist && status_login) {
              // Ensure password and password_confirmation are the same
              const password = cartDomainBundle.password || '';
              const password_confirmation = cartDomainBundle.password_confirmation || password;

              const omgIdData = {
                username: cartDomainBundle.onlineId,
                name: cartDomainBundle.name || data_login?.client?.firstname || data_login?.user?.first_name || cartDomainBundle.onlineId,
                email: cartDomainBundle.email || data_login?.user?.email || data_login?.client?.email || '',
                password: password,
                password_confirmation: password_confirmation, // Always use same password
                invoice_id: invoiceId,
                client_id: data_login?.client?.id || data_login?.user?.id || 0,
              };

              // Only register if we have all required data
              if (omgIdData.username && omgIdData.email && omgIdData.password) {
                fetchBundleRegisterOmgId(omgIdData)
                  .then((result) => {
                    if (result.code === 200) {
                      console.log("Omg.id registration data saved successfully:", result);
                    } else {
                      console.error("Failed to save omg.id registration:", result);
                    }
                  })
                  .catch((error) => {
                    console.error("Error saving omg.id registration:", error);
                  });
              }
            }

            // Keep modal open until redirect happens
            setTimeout(() => {
              redirectToInvoice(invoiceId, { recordGa4Purchase: true });
            }, 5000); // 5 seconds
          } else {
            setShowOrderProgress(false);
            setTimeout(() => {
              checkoutButton.innerText = "Selesaikan Pesananmu";
              checkoutButton.disabled = false;
              dispatch(checkoutProcess(false));
              setLoading(false);
              notifyError(order?.result || order?.msg || "Terjadi kesalahan saat memproses pesanan");
            }, 2000);
          }
        } else if (cartOrderProcessName === "upgrade") {
          // Handle upgrade response
          if (order?.code === 200 && order?.data?.order?.result === "success") {
            // Keep modal open until redirect happens
            setTimeout(() => {
              redirectToInvoice(order.data.order.invoiceid, { recordGa4Purchase: true });
            }, 5000); // 5 seconds
          } else if (order?.code === 200 && order?.data?.existing_order) {
            // Handle case: existing unpaid invoice or existing order
            const invoiceId = order.data.existing_order.invoiceid || order.data.payment_url?.split('/invoice/')[1];
            if (invoiceId) {
              notifyError(order?.message || "Ada invoice yang belum dibayar. Mengarahkan ke invoice...");
              // Keep modal open until redirect happens
              setTimeout(() => {
                redirectToInvoice(invoiceId);
              }, 5000); // 5 seconds delay
            } else {
              setShowOrderProgress(false);
              setTimeout(() => {
                checkoutButton.innerText = "Selesaikan Pesananmu";
                checkoutButton.disabled = false;
                dispatch(checkoutProcess(false));
                setLoading(false);
                notifyError(order?.message || "Terjadi kesalahan saat memproses upgrade");
              }, 2000);
            }
          } else if (order?.data?.payment_url) {
            // Handle case: unpaid invoice with payment_url
            const invoiceId = order.data.payment_url.split('/invoice/')[1];
            if (invoiceId) {
              notifyError(order?.message || "Ada invoice yang belum dibayar. Mengarahkan ke invoice...");
              // Keep modal open until redirect happens
              setTimeout(() => {
                redirectToInvoice(invoiceId);
              }, 5000); // 5 seconds delay
            } else {
              setShowOrderProgress(false);
              setTimeout(() => {
                checkoutButton.innerText = "Selesaikan Pesananmu";
                checkoutButton.disabled = false;
                dispatch(checkoutProcess(false));
                setLoading(false);
                notifyError(order?.error || order?.message || "Terjadi kesalahan saat memproses upgrade");
              }, 2000);
            }
          } else {
            setShowOrderProgress(false);
            setTimeout(() => {
              checkoutButton.innerText = "Selesaikan Pesananmu";
              checkoutButton.disabled = false;
              dispatch(checkoutProcess(false));
              setLoading(false);
              notifyError(order?.error || order?.message || "Terjadi kesalahan saat memproses upgrade");
            }, 2000);
          }
        } else if (cartOrderProcessName === "addon") {
          // Handle addon response
          if (order?.code === 200 && order?.data?.order?.result === "success") {
            // Keep modal open until redirect happens
            setTimeout(() => {
              redirectToInvoice(order.data.order.invoiceid, { recordGa4Purchase: true });
            }, 5000); // 5 seconds
          } else {
            setShowOrderProgress(false);
            setTimeout(() => {
              checkoutButton.innerText = "Selesaikan Pesananmu";
              checkoutButton.disabled = false;
              dispatch(checkoutProcess(false));
              setLoading(false);
              notifyError(order?.error || order?.message || "Terjadi kesalahan saat memproses addon");
            }, 2000);
          }
        } else {
          if (order?.code === 200 && order?.data?.order) {
            const { invoiceid = 0 } = order.data.order;
            setIsProcessingNetOffer(false); // Reset processing state
            // Keep modal open until redirect happens
            redirectToInvoice(invoiceid, {
              recordGa4Purchase:
                order?.data?.order?.result === "success" && Number(invoiceid) > 0,
            });
          } else {
            // Handle case where order response is not as expected
            checkoutButton.innerText = "Selesaikan Pesananmu";
            checkoutButton.disabled = false;
            dispatch(checkoutProcess(false));
            setLoading(false);
            setIsProcessingNetOffer(false); // Reset processing state
            notifyError(order?.result || order?.msg || "Format response tidak valid");
          }
        }
       } catch (err) {
         console.warn(err.message, "continueCheckout Function");
         setShowOrderProgress(false);
         if (err.message === "Invalid Data") {
           notifyError(
             "Pemesanan Anda tidak valid. Silakan ulangi pemesanan Anda."
           );
         } else {
           notifyError(err.message);
         }
         try {
           if (checkoutButton && checkoutButton.parentNode) {
             checkoutButton.innerText = "Selesaikan Pesananmu";
             checkoutButton.disabled = false;
           }
         } catch (error) {
           console.warn("Error resetting checkout button in catch:", error);
         }
         dispatch(checkoutProcess(false));
         setLoading(false);
         setIsProcessingNetOffer(false); // Reset processing state
       }
    }
  };

  return (
    <>
      {/* Debug Button untuk Modal Upload KTP - Floating Button */}
      {process.env.NODE_ENV === 'development' && (
        <button
          className="btn btn-outline-warning btn-sm"
          onClick={() => setModalImage(true)}
          type="button"
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 9999,
            borderRadius: '50px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            padding: '10px 15px'
          }}
        >
          🐛 Debug: Test Modal Upload KTP
        </button>
      )}

      <ErrorBoundary>
        <div
          className={`${cartProductsList.length === 0 ? "mt-auto" : "mt-3"} d-grid`}
        >
        <button
          className="btn btn-cta rounded-5 checkout-button"
          id="checkoutButton"
          onClick={checkoutHandle}
          disabled={cartProductsList.length === 0 || loading || isProcessingNetOffer || isCheckingPremium}
        >
          {loading || isProcessingNetOffer || isCheckingPremium ? <Spinner animation="border" size="sm" /> : "Selesaikan Pesananmu"}
        </button>
      </div>

      <ModalLogin
        show={showLogin}
        onHide={() => {
          setModalLogin(false);
          resetLoadingState();
        }}
        onClickDaftar={(showDaftar) => {
          setModalDaftar(showDaftar);
          if (showDaftar) {
            setModalLogin(false);
          }
        }}
        onClickLogin={setModalLogin}
      />
      <ModalRegisterSimple
        show={showDaftar}
        onHide={() => {
          setModalDaftar(false);
          resetLoadingState();
        }}
        onClickDaftar={setModalDaftar}
        onClickLogin={(showLogin) => {
          setModalLogin(showLogin);
          if (showLogin) {
            setModalDaftar(false);
          }
        }}
      />
      <ModalUploadImage
        show={modalImage}
        onHide={modalHideHandler}
        handler={setModalImage}
        backdrop="static"
      />
      <ModalConfirmCheckout
        show={modalConfirmation}
        onHide={handlerCloseModal}
      />
      <ModalFakturPajak
        show={modalFaktur}
        onHide={() => {
          setModalFaktur(false);
          resetLoadingState();
        }}
      />
      <ModalPph
        show={modalPph}
        onHide={() => {
          setModalPph(false);
          resetLoadingState();
        }}
      />
      <ModalSubDomain
        show={modalSubDomain}
        onHide={() => {
          setModalSubDomain(false);
          resetLoadingState();
        }}
        domain={existingDomain ? existingDomain.domain : ""}
      />
      <ModalNetInstallation
        show={modalNetInstallation}
        onHide={handleNetInstallationHide}
        onSkip={handleNetInstallationSkip}
        onAccept={handleNetInstallationAccept}
      />
      <ModalOrderProgress
        show={showOrderProgress}
      />
      </ErrorBoundary>
    </>
  );
};

export default CheckoutButton;
